<template>
  <div class="app-page">
    <section>
      <NuxtPage />
    </section>
  </div>
</template>
